// Builds Decca's opening message when the user clicks "Vraag Decca om advies"
// on the Theory of Change navigator. The greeting reflects WHERE the user is so
// the first message isn't generic: cold start vs. a specific step/node, detail
// vs. overview. Non-technical, mission-first tone (see the TOC agent persona).
//
// Pure → unit-tested. Returns an HTML string (matching the greeting format used
// by DeccaTriggerButton / other Decca openers).
//
// See docs/features/decca-toc-integration.md.

/**
 * @param {object} params
 * @param {string} [params.userName] - The user's first name.
 * @param {string} [params.stepLabel] - Dutch label of the current step (e.g. "Effect").
 * @param {string} [params.nodeTitle] - Title of the focused node, when one is selected.
 * @param {'detail'|'overview'} [params.mode] - Navigator mode.
 * @param {boolean} [params.isEmpty] - True when the Theory of Change has no doelgroep yet.
 * @returns {string} HTML greeting for the first assistant message.
 */
const tocDeccaGreeting = ({ userName, stepLabel, nodeTitle, mode, isEmpty } = {}) => {
  const hi = `Hallo ${userName || ''}`.trim()
  const step = (stepLabel || '').toLowerCase()

  if (isEmpty) {
    return `<h2>${hi}</h2><p>Zal ik je helpen je Theory of Change op te zetten? Vertel me eerst kort: wat wil je organisatie bereiken, en voor wie?</p>`
  }

  if (mode === 'overview') {
    const what = step ? `het overzicht van de stap ${step}` : 'je Theory of Change'
    return `<h2>${hi}</h2><p>Je bekijkt ${what}. Zal ik met je meedenken over deze stap?</p>`
  }

  // detail mode
  if (nodeTitle && step) {
    return `<h2>${hi}</h2><p>Je werkt aan ${step} '${nodeTitle}'. Zal ik meekijken naar wat hier nog kan worden aangescherpt?</p>`
  }
  if (step) {
    return `<h2>${hi}</h2><p>Je werkt aan de stap ${step}. Zal ik met je meedenken?</p>`
  }
  return `<h2>${hi}</h2><p>Zal ik met je meedenken over je Theory of Change?</p>`
}

export default tocDeccaGreeting
